import { useContext } from 'react';
import Alert from '@pelckmans/elementis/components/alert';
import Button from '@pelckmans/elementis/components/button';
import ModalContext from '../../../../contexts/ModalContext';
import AddLicenseModal from '../../../../shared-components/AddLicenseModal';
import { useTranslation } from 'react-i18next';
import ModuleContext from '../../_contexts/ModuleContext';
import IdentityContext from '../../../../contexts/IdentityContext';

export default function ModuleLicenseAlert() {
  const { showModal } = useContext(ModalContext);
  const { t } = useTranslation();
  const {
    identity: { isTeacherAlike },
  } = useContext(IdentityContext);
  const { selectedModule: module, refetch: refetchModule } = useContext(ModuleContext);

  if (!module) return null;

  const renderAlert = (messageKey: string) => (
    <Alert
      prominence="warning"
      actions={{
        'aria-label': 'Buttons',
        role: 'group',
        size: 'sm',
        children: (
          <Button
            key="info-ok"
            prominence="warning"
            size="sm"
            onClick={() => showModal(<AddLicenseModal id="add-license-modal" onRefetch={refetchModule} />)}
          >
            {t('PAGES.TOC_LEVEL.ALERTS.BUTTON_ACTIVATE.MESSAGE')}
          </Button>
        ),
      }}
    >
      {t(messageKey)}
    </Alert>
  );

  const { hasDocumentLicenseForStudent, hasDocumentLicenseForTeacher, hasDigitalManualLicenseForTeacher } =
    module.licenses;

  if (!isTeacherAlike && !hasDocumentLicenseForStudent) {
    return renderAlert('PAGES.TOC_LEVEL.ALERTS.STUDENT_HAS_NO_DOCUMENT_LICENSE.MESSAGE');
  }

  if (isTeacherAlike && !hasDocumentLicenseForTeacher) {
    return renderAlert('PAGES.TOC_LEVEL.ALERTS.TEACHER_HAS_NO_DOCUMENT_LICENSE.MESSAGE');
  }

  if (isTeacherAlike && hasDocumentLicenseForTeacher && !hasDigitalManualLicenseForTeacher) {
    return renderAlert('PAGES.TOC_LEVEL.ALERTS.TEACHER_HAS_NO_DIGITAL_MANUAL_LICENSE.MESSAGE');
  }

  return null;
}
